import { Component, Input, ViewEncapsulation } from '@angular/core';
import { MechanicsService } from '../../_services/mechanics.service';

@Component({
	selector: 'doc-field-array',
	templateUrl: './doc-field-array.component.html',
	styleUrls: ['./doc-field-array.component.css'],
	standalone: false
})
export class FieldArrayComponent {

	@Input() field: any;

	public isExpanded: boolean = true; // Togglable ellipsis in case of long text

	constructor(public ms: MechanicsService) { }

	get hasEllipsis() {
		return false
		// return this.field.content && this.field.content.length > 500
	}

}
